import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { SharedModule } from "src/app/shared/shared.module";
import { ReferralRewardsDashboardComponent } from "./components/referral-rewards-dashboard/referral-rewards-dashboard.component";
import { ReferralRewardsDialogComponent } from "./components/referral-rewards-dialog/referral-rewards-dialog.component";
import { ReferralRewardsFeatureButtonComponent } from "./components/referral-rewards-feature-button/referral-rewards-feature-button.component";
import { ReferralRewardsHistoryComponent } from "./components/referral-rewards-history/referral-rewards-history.component";
import { ReferralRewardsHowItWorksComponent } from "./components/referral-rewards-how-it-works/referral-rewards-how-it-works.component";
import { ReferralRewardsInviteInputComponent } from "./components/referral-rewards-invite-input/referral-rewards-invite-input.component";
import { ReferralRewardsTabsComponent } from "./components/referral-rewards-tabs/referral-rewards-tabs.component";

const SHARED_COMPONENTS = [ReferralRewardsFeatureButtonComponent, ReferralRewardsDashboardComponent];

@NgModule({
  declarations: [
    ...SHARED_COMPONENTS,
    ReferralRewardsDialogComponent,
    ReferralRewardsHowItWorksComponent,
    ReferralRewardsInviteInputComponent,
    ReferralRewardsHistoryComponent,
    ReferralRewardsTabsComponent,
  ],
  imports: [SharedModule, RouterModule],
  exports: SHARED_COMPONENTS,
})
export class ReferralRewardsModule {}
